<template>
  <div>
    <div v-show="isLoading" class="loader">
      <b-spinner class="align-middle mb-3"></b-spinner>
      <strong>{{ 'Loading...' }}</strong>
    </div>

    <div v-show="!isLoading">
      <div v-if="result?.totalFailed === 0" class="card p-4">
        <div class="success text-center">
          <img width="385" height="287" alt="upload success" :src="uploadSuccessImg" />
          <h5 class="mt-2 mb-3">{{ $t('global.importResult.successUpload') }}</h5>
          <p>{{ $t('maintenance.form.backToList') }}</p>
        </div>
      </div>

      <b-tabs v-else v-model="activeTab" lazy>
        <b-tab :title="$t('maintenance.form.kmTime')" class="card p-4">
          <ResultTable :fields="distanceTimeFields" :items="distanceTimeItems">
            <template #thead-top>
              <b-tr>
                <b-th rowspan="2" style="min-width: 40px; width: 40px">
                  {{ '' }}
                </b-th>
                <b-th rowspan="2">
                  {{ $t('global.object.licensePlate') }}
                </b-th>
                <b-th rowspan="2">
                  {{ $t('maintenance.field.compName') }}
                </b-th>
                <b-th rowspan="2">
                  {{ $t('global.activity') }}
                </b-th>
                <b-th rowspan="2">
                  {{ $t('maintenance.form.catService') }}
                </b-th>
                <b-th rowspan="2">
                  {{ `${$t('maintenance.field.firstService')} (Km)` }}
                </b-th>
                <b-th rowspan="2">
                  {{ `${$t('maintenance.field.firstService')} (${$t('global.field.date')})` }}
                </b-th>
                <b-th rowspan="2">
                  {{ $t('maintenance.form.intKm') }}
                </b-th>
                <b-th rowspan="2">
                  {{ $t('maintenance.form.remindKm') }}
                </b-th>
                <b-th colspan="2">
                  {{ $t('maintenance.form.intTime') }}
                </b-th>
                <b-th colspan="2">
                  {{ $t('maintenance.form.remindTime') }}
                </b-th>
                <b-th rowspan="2">
                  {{ $t('maintenance.field.method') }}
                </b-th>
              </b-tr>
            </template>
          </ResultTable>
        </b-tab>
        <b-tab :title="$t('maintenance.form.hourmeter')" class="card p-4">
          <ResultTable :fields="hourmeterFields" :items="hourmeterItems" />
        </b-tab>
        <b-tab v-if="isMGMAndMO" :title="$t('maintenance.form.refrigerator')" class="card p-4">
          <ResultTable :fields="refrigeratorFields" :items="refrigeratorItems" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import uploadSuccessImg from '@/assets/images/upload-success.png'
import { distanceTimeFields, hourmeterFields, refrigeratorFields } from '../lib/uploadResultFields'
import ResultTable from '../components/Table'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'

export default {
  components: {
    ResultTable,
  },
  data() {
    return {
      activeTab: 0,
      distanceTimeFields,
      hourmeterFields,
      refrigeratorFields,
      isLoading: false,
      result: this.$store.state.maintenance.importData,
      distanceTimeItems: [],
      hourmeterItems: [],
      refrigeratorItems: [],
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    uploadSuccessImg() {
      return uploadSuccessImg
    },
    isMGMAndMO() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(Helper.methods.getCompanyId()) &&
        data.features?.maintenance_order
      )
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.isLoading = true
      this.distanceTimeItems = this.result.data.sheet1
      this.hourmeterItems = this.result.data.sheet2
      this.refrigeratorItems = this.result.data.sheet3
      this.isLoading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.loader {
  min-height: min(50vh, 500px);
  display: grid;
  place-items: center;
  place-content: center;
  background-color: white;
}
</style>
